import { createAction } from "redux-act";

export const OpenNewFilterModalAction = createAction("New Filter - Open Modal");
export const CloseNewFilterModalAction = createAction("New Filter - Close Modal");
